export default {
  computed: {
    allPartnerTypes: function () {
      return this.$store.state.PartnerTypeStore.all_partner_types
    },
    allPartners: function () {
      return this.$store.state.PartnerStore.all_partners
    },
    allPartnerDestinations: function () {
      return this.$store.state.PartnerStore.partner_destinations
    },
    partnerDestinationsArr: function () {
      var destinations = []
      for (var i = 0; i < this.$store.state.PartnerStore.partner_destinations.length; i++) {
        destinations.push(this.$store.state.PartnerStore.partner_destinations[i].destination_id)
      }
      return destinations
    },
    $tourOperators: function () {
      return this.allPartners.filter(function (partner) {
        return partner.type_public_id === '6bac8c28'
      })
    },
    partnerUsers: function () {
      
      return this.$store.state.UserStore.users
    },
    allPartnerBookings: function () {
      return this.$store.state.BookingStore.all_partner_bookings
    },
    partnerBookings: function () {
      return this.$store.state.BookingStore.partner_bookings
    },
    singlePartner: function () {
      return this.$store.state.PartnerStore.partner
    },
    updatePartner: function () {
      
      if (this.$route.name === 'EditPartner') {
        this.partner.partner_type = this.singlePartner.type_public_id
        this.partner.name = this.singlePartner.name
        this.partner.postal_address = this.singlePartner.postal_address
        this.partner.postal_code = this.singlePartner.postal_code
        this.partner.customer_code = this.singlePartner.customer_code
        this.partner.customer_code_usd = this.singlePartner.customer_code_usd
        this.partner.email = this.singlePartner.email
        this.partner.tel_number = this.singlePartner.tel
        this.partner.kra_pin_number = this.singlePartner.kra_pin_number
        this.partner.destinations = this.partnerDestinationsArr
      }
    }
  }
}
